// import encodeObjForm from './encodeObjForm.json'
import { objectCamelToSnakeCase } from "./libUtil"
import axios from "axios";

// function findKey(form, value) {
//     return Object.keys(form).find(key => form[key] === value);
// }


async function createForm(endpoint, form) {
    return new Promise((resolve, reject) => {
        let encoded_form = objectCamelToSnakeCase(form)
        // console.log(encoded_form)
        axios.post(endpoint, encoded_form)
            .then((response) => {
                resolve(response)
            })
            .catch(error => {
                reject(error)
            })
    })
}

async function editForm(endpoint, form) {
    return new Promise((resolve, reject) => {
        let encoded_form = objectCamelToSnakeCase(form)
        // console.log(encoded_form)
        axios.put(endpoint + form.id + '/', encoded_form)
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

async function deleteForm(endpoint, form) {
    return new Promise((resolve, reject) => {
        axios.delete(endpoint + form.id + '/')
            .then(() => {
                resolve("Success")
            })
            .catch(() => {
                reject("Fail")
            })
    })
}

function areEqualForm(form1, form2) {
    let fields = [
        'nombre',
        'documento',
        'tipoDocumento',
        // 'telefonosContacto',
        'email',
        'direccion',
        'cp',
        'localidad',
        'fechaContacto',
        // 'origenBbdd',
        'segmento',
        'ispActual',
        'cups',
        'iban',
        // 'comercial',
        'razonNoInteresado',
        'notas',
    ]

    let equal = true

    fields.forEach((field) => {
        if (form1[field] != form2[field]) {
            equal = false
            return equal
        }
    })

    if (form1.comercial && form2.comercial) {
        if (form1.comercial.id != form2.comercial.id) {
            equal = false
        }
    } else if (form1.comercial || form2.comercial) {
        equal = false
    }

    if (form1.origenBbdd && form2.origenBbdd) {
        if (form1.origenBbdd.id != form2.origenBbdd.id) {
            equal = false
        }
    } else if (form1.origenBbdd || form2.origenBbdd) {
        equal = false
    }

    if (form1.telefonosContacto.length != form2.telefonosContacto.length) {
        equal = false
    }

    return equal
}

export {
    createForm,
    editForm,
    deleteForm,
    areEqualForm
}